// API and File Server configuration for TrueNAS deployment
// Supports local network (192.168.0.11) and Tailscale (100.108.217.117) access

const TAILSCALE_IP = '100.108.217.117';
const LOCAL_NAS_IP = '192.168.0.11';

const getApiUrl = (): string => {
  const hostname = window.location.hostname;
  const port = window.location.port;

  console.log('Detected hostname:', hostname);
  console.log('Detected port:', port);

  // When accessed through nginx proxy (port 8080), use relative path
  // nginx will proxy /api to backend:5000
  if (port === '8080') {
    console.log('Using nginx proxy for API (port 8080)');
    return '/api'; // nginx will handle proxying to backend:5000
  }

  // Tailscale access - direct to backend port
  if (hostname === TAILSCALE_IP || hostname.includes('tailscale') || hostname.includes('ts.net')) {
    console.log('Using Tailscale API URL');
    return `http://${TAILSCALE_IP}:5000/api`;
  }

  // TrueNAS local network access - direct to backend port
  if (hostname === LOCAL_NAS_IP || hostname.startsWith('192.168.')) {
    console.log('Using local network API URL');
    return `http://${hostname}:5000/api`;
  }

  // Local development - use local backend
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    console.log('Using local backend for development');
    return 'http://localhost:5000/api';
  }

  // Fallback - assume we're being served from nginx
  console.log('Using fallback nginx proxy API URL');
  return '/api';
};

const getFileServerUrl = (): string => {
  const hostname = window.location.hostname;
  const port = window.location.port;

  // When accessed through nginx proxy (port 8080)
  // File server is separate from nginx, so use the detected network
  if (port === '8080') {
    // Check if we're on Tailscale by looking at the hostname
    if (hostname === TAILSCALE_IP) {
      return `http://${TAILSCALE_IP}:8083`;
    }
    // Default to local NAS for port 8080 access
    return `http://${LOCAL_NAS_IP}:8083`;
  }

  // Tailscale access
  if (hostname === TAILSCALE_IP || hostname.includes('tailscale') || hostname.includes('ts.net')) {
    return `http://${TAILSCALE_IP}:8083`;
  }

  // Local network access
  if (hostname === LOCAL_NAS_IP || hostname.startsWith('192.168.')) {
    return `http://${LOCAL_NAS_IP}:8083`;
  }

  // Local development still uses the NAS file server.
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return `http://${LOCAL_NAS_IP}:8083`;
  }

  // Public HTTPS uses nginx's same-origin file proxy.
  return '';
};

export const API_BASE_URL = getApiUrl();
export const FILE_SERVER_URL = getFileServerUrl();

// Log the URLs for debugging
console.log('API URL configured as:', API_BASE_URL);
console.log('File Server URL configured as:', FILE_SERVER_URL);